var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6 9.5V2.5M9.5 6H2.5","stroke":"white","stroke-linecap":"round"}})])}
var staticRenderFns = []

export { render, staticRenderFns }